import styled from "@emotion/styled";

export const AddOrdersPageErrorBannerWrapper = styled.div(({ theme }) => ({
	marginBottom: 20
}));

export const AddOrdersPageContentWrapper = styled.div(({ theme }) => ({
	padding: 20,
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	ul: {
		marginTop: 0
	},
	"& .MuiAlert-root p": {
		margin: 0
	}
}));

export const TruckInfoOrdersContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: 16,
	alignItems: "flex-start"
}));

export const NoOrdersContainer = styled.div(({ theme }) => ({
	width: "100%",
	backgroundColor: theme.project.colors.backgroundColors.main
}));
